import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHtmlHashRedirect } from '../controllers/useHtmlHashRedirect';
import V2Footer from './components/V2Footer';
import V2Header from './components/V2Header';

export default function V2Layout({ children }) {
  const location = useLocation();
  useHtmlHashRedirect();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const scrollToSection = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      if (!scrollToSection()) {
        requestAnimationFrame(() => {
          scrollToSection();
        });
      }
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return (
    <>
      <V2Header />
      {children}
      <V2Footer />
    </>
  );
}

